import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, HostListener, Inject } from '@angular/core';

@Directive({
    selector: '[scrollToTop]'
})
export class ScrollToTopDirective {
    constructor(private el: ElementRef<HTMLElement>) { }

    @HostListener('click')
    onClick() {
        this.el.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}

@Directive({
    selector: '[scrollToHeader]'
})
export class ScrollToHeaderDirective {
    constructor(@Inject(DOCUMENT) private document: Document) { }

    @HostListener('click')
    onClick(): void {
        // scroll the <html> element to top
        this.document.documentElement.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // fallback for some browsers if needed:
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}